<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    redirectText: string
    redirectType: 'signIn' | 'signUp'
  }>(),
  {},
)

const clerk = useClerk()
const app = useApp()
const { user, isLoaded } = useUser()

whenever(
  isLoaded,
  () => {
    if (user.value) {
      navigateTo('/', { replace: true })
      return
    }
    app.data.loadingRedirectStatus = props.redirectText

    if (props.redirectType === 'signIn') {
      clerk.value?.redirectToSignIn()
    } else if (props.redirectType === 'signUp') {
      clerk.value?.redirectToSignUp()
    }
  },
  { immediate: true },
)
</script>

<template>
  <div />
</template>
